import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './SignupForm.css'
import config from '../../config'


@CSSModules(Styles)
export default class SignupForm extends Component {
  static propTypes = {
    url: PropTypes.string,
    id: PropTypes.string
  }
  constructor(props){
    super(props)
    this.state = {
      url: this.props.url || config.signupForm.url,
      id: this.props.id || config.signupForm.id
    }
  }

  componentDidUpdate() {
    this.myFormRef.reset();
  }

  render() {
    const { url, id } = this.state
    //
    return (
      <div styleName='form-wrap'>
        <form
          styleName='form'
          acceptCharset='UTF-8'
          method='post'
          action={url}
          target='signup_confirmation'
          ref={ (el) => this.myFormRef = el }
        >
          <input styleName='input'
            name={id}
            type='email'
            placeholder='Get email updates'
            required
          />
          <div
            style={{
              position: 'absolute',
              left: '-9999px',
              top: '-9999px',
            }}
          >
            <label htmlFor="pardot_extra_field">Comments</label>
            <input
              type="text"
              id="pardot_extra_field"
              name="pardot_extra_field"
            />
          </div>
          <button
            styleName='submit'
            type='submit'
            value=''
          >
            Sign up
          </button>
        </form>
      </div>
    )
  }
}
